// extracted by mini-css-extract-plugin
export default {"previousButton":"Eq6Y7n"};